import React, { useState, useEffect } from "react";
import axios from "axios";

// fallback images (optional)
import programImg1 from "../Asstes/Images/company-program-1.png";
import programImg2 from "../Asstes/Images/company-program-2.png";
import listIcon from "../Asstes/Images/lists-icon.svg";
import config from "../config";

const CompanyOneprograme = () => {
  const [banner, setBanner] = useState(null);
  const [content, setContent] = useState([]);
  const [loadingBanner, setLoadingBanner] = useState(true);
  const [loadingContent, setLoadingContent] = useState(true);
  const [errorBanner, setErrorBanner] = useState(null);
  const [errorContent, setErrorContent] = useState(null);

  useEffect(() => {
    // fetch banner
    axios
      .get(
        "/prosapiens-cms/public/api/banners/1-percent-program"
      )
      .then((res) => {
        if (res.data.banners && res.data.banners.length > 0) {
          setBanner(res.data.banners[0]);
        } else {
          setErrorBanner("No banner data found");
        }
      })
      .catch(() => setErrorBanner("Failed to fetch banner data"))
      .finally(() => setLoadingBanner(false));

    // fetch content
    axios
      .get(
        "/prosapiens-cms/public/api/content/1-percent-program"
      )
      .then((res) => {
        if (res.data.content && res.data.content.length > 0) {
          setContent(res.data.content);
        } else {
          setErrorContent("No content data found");
        }
      })
      .catch(() => setErrorContent("Failed to fetch content data"))
      .finally(() => setLoadingContent(false));
  }, []);

  // Extract content by order
  const content1 = content.find((c) => c.content_order === "1");
  const content2 = content.find((c) => c.content_order === "2");
  const content3 = content.find((c) => c.content_order === "3");
  const content4 = content.find((c) => c.content_order === "4");

  // Determine contact link dynamically from content4.link_url or banner.link_url fallback
  // The APIs show content4.link_url: "0" which isn't a valid URL, so fallback to banner.link_url or use "/contact"
  const contactLink =
    (content4 &&
      content4.link_url &&
      content4.link_url !== "0" &&
      content4.link_url) ||
    (banner && banner.link_url && banner.link_url !== "0" && banner.link_url) ||
    "/contact";

  return (
    <>
      {/* Banner Section */}
      <section className="company-one-bg">
        <div className="overlay container">
          <div className="hero-text">
            {loadingBanner && <p>Loading banner...</p>}
            {errorBanner && <p style={{ color: "red" }}>{errorBanner}</p>}
            {!loadingBanner && !errorBanner && banner && (
              <>
                <h1
                  dangerouslySetInnerHTML={{
                    __html: banner.banner_title.replace(/\n/g, "<br />"),
                  }}
                />
                <p
                  style={{ color: "#fff" }}
                  dangerouslySetInnerHTML={{ __html: banner.content_text }}
                />
              </>
            )}
          </div>
        </div>
      </section>

      {/* Mobile Banner Section */}
      <section className="company-one-mobile">
        <div className="overlay container">
          <div className="hero-text">
            {loadingBanner && <p>Loading banner...</p>}
            {errorBanner && <p style={{ color: "red" }}>{errorBanner}</p>}
            {!loadingBanner && !errorBanner && banner && (
              <>
                <h1
                  dangerouslySetInnerHTML={{
                    __html: banner.banner_title.replace(/\n/g, "<br />"),
                  }}
                />
                <p
                  style={{ color: "#fff" }}
                  dangerouslySetInnerHTML={{ __html: banner.content_text }}
                />
              </>
            )}
          </div>
        </div>
      </section>

      {/* Content 1 Section */}
      <section className="what-we-do">
        <div className="container">
          <div className="image-container">
            <div className="image-side" data-aos="fade-right">
              {loadingContent && <p>Loading content...</p>}
              {errorContent && <p style={{ color: "red" }}>{errorContent}</p>}
              {!loadingContent &&
              !errorContent &&
              content1 &&
              content1.content_image ? (
                <img
                  src={`/prosapiens-cms/public/${content1.content_image}`}
                  alt={content1.content_title || "Content Image"}
                />
              ) : (
                <img src={programImg1} alt="Fallback Image" />
              )}
            </div>

            <div
              className="text-side"
              data-aos="fade-left"
              dangerouslySetInnerHTML={{
                __html: content1 ? content1.content_text : "",
              }}
            />
          </div>
        </div>
      </section>

      {/* Content 2 Section */}
      <div className="container" data-aos="fade-up">
        {loadingContent && <p>Loading content...</p>}
        {errorContent && <p style={{ color: "red" }}>{errorContent}</p>}

        {!loadingContent && !errorContent && content2 ? (
          <section
            className="smart-hiring-process"
            dangerouslySetInnerHTML={{ __html: content2.content_text }}
          />
        ) : null}
      </div>

      {/* Content 3 Section (with image and HTML split) */}
      <section className="company-one-sec">
        <div className="container">
          <div className="image-container">
            {loadingContent && <p>Loading content...</p>}
            {errorContent && <p style={{ color: "red" }}>{errorContent}</p>}
            {!loadingContent && !errorContent && content3 && (
              <>
                {content3.content_image && (
                  <div className="image-side" data-aos="fade-right">
                    <img
                      src={`/prosapiens-cms/public/${content3.content_image}`}
                      alt={content3.content_title || "Content 3 Image"}
                    />
                  </div>
                )}
                <div
                  className="text-side about"
                  data-aos="fade-left"
                  dangerouslySetInnerHTML={{ __html: content3.content_text }}
                />
              </>
            )}
          </div>
        </div>
      </section>

      {/* Content 4 Section (CTA with dynamic link) */}
      <div className="container">
        <div className="hire-box" data-aos="fade-up">
          <div>
            {loadingContent && <p>Loading content...</p>}
            {errorContent && <p style={{ color: "red" }}>{errorContent}</p>}

            {!loadingContent && !errorContent && content4 && (
              <>
                <div
                  className="tagline"
                  dangerouslySetInnerHTML={{
                    __html:
                      content4.content_text.match(
                        /<div class="tagline">.*?<\/div>/s
                      )?.[0] || "",
                  }}
                />
                <h2
                  dangerouslySetInnerHTML={{
                    __html: content4.content_text
                      .replace(/<div class="tagline">.*?<\/div>/s, "")
                      .trim(),
                  }}
                />
              </>
            )}
          </div>
          <a href="/contact" className="cta-yellow">
            Contact Us →
          </a>
        </div>
      </div>
    </>
  );
};

export default CompanyOneprograme;
